import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import Grid24 from '../../../../components/UI/Grid24';
import { loadingInspecaoProcessoController } from '../../loadingInspecaoProcessoController';
import { getExceptionErrorMessage, isBadRequestException, openPagePDF } from '../../../../helpers';
import { enviarMemoriaDeCalculoPorEmail, imprimirRelatorioMemoriaDeCalculoPropostaAcordo } from '../../../../services/core/processos/processosTitulosService';

function DialogMemoriaDeCalculo({
  onClose, setLoadings, idProcesso, payloadPropostaAcordo = null,
}) {
  const toMoneyNumber = useCallback((value) => {
    const parsedValue = Number(value);
    if (!Number.isFinite(parsedValue)) {
      return 0;
    }
    return Number(parsedValue.toFixed(2));
  }, []);

  const montarJsonTitulos = useCallback((jsonTitulos) => {
    if (!jsonTitulos) {
      return '[]';
    }

    try {
      const parsedTitulos = typeof jsonTitulos === 'string' ? JSON.parse(jsonTitulos) : jsonTitulos;
      if (!Array.isArray(parsedTitulos)) {
        return '[]';
      }

      const titulosNormalizados = parsedTitulos.map(titulo => ({
        idTitulo: Number(titulo?.idTitulo) || 0,
        valorOriginal: toMoneyNumber(titulo?.valorOriginal),
        valorSaldoPrincipal: toMoneyNumber(titulo?.valorSaldoPrincipal),
        valorProtesto: toMoneyNumber(titulo?.valorProtesto),
        valorMulta: toMoneyNumber(titulo?.valorMulta),
        valorJurosCliente: toMoneyNumber(titulo?.valorJurosCliente),
        valorJurosABE: toMoneyNumber(titulo?.valorJurosABE ?? titulo?.valorJurosAbe),
        valorHonorarios: toMoneyNumber(titulo?.valorHonorarios),
        valorDesconto: toMoneyNumber(titulo?.valorDesconto),
        valorTotal: toMoneyNumber(titulo?.valorTotal),
      }));

      return JSON.stringify(titulosNormalizados);
    } catch (error) {
      return '[]';
    }
  }, [toMoneyNumber]);

  const montarPayloadPropostaAcordo = useCallback((payload) => {
    if (!payload) {
      return null;
    }

    return {
      valorSaldo: toMoneyNumber(payload.valorSaldo),
      valorJurosAbe: toMoneyNumber(payload.valorJurosAbe ?? payload.valorJurosABE),
      valorJurosCliente: toMoneyNumber(payload.valorJurosCliente),
      valorHonorarios: toMoneyNumber(payload.valorHonorarios),
      valorProtesto: toMoneyNumber(payload.valorProtesto),
      valorMulta: toMoneyNumber(payload.valorMulta),
      valorDesconto: toMoneyNumber(payload.valorDesconto),
      valorTotal: toMoneyNumber(payload.valorTotal),
      valorJuros: toMoneyNumber(payload.valorJuros),
      valorSubTotal: toMoneyNumber(payload.valorSubTotal),
      jsonTitulos: montarJsonTitulos(payload.jsonTitulos),
      porcentagemTaxaCartao: toMoneyNumber(payload.porcentagemTaxaCartao),
      valorTaxaCartao: toMoneyNumber(payload.valorTaxaCartao),
    };
  }, [montarJsonTitulos, toMoneyNumber]);

  const imprimirMemoriaDeCalculo = useCallback(async () => {
    setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(true));
    try {
      const payload = montarPayloadPropostaAcordo(payloadPropostaAcordo);
      const response = await imprimirRelatorioMemoriaDeCalculoPropostaAcordo(payload);

      if (response?.data?.size > 0) {
        openPagePDF(response.data);
      }
      onClose();
    } catch (error) {
      if (isBadRequestException(error)) {
        toast.error(error?.response?.data?.message, { style: { width: '392px' } });
      } else {
        toast.error(getExceptionErrorMessage(error), { style: { width: '392px' } });
      }
    } finally {
      setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(false));
    }
  }, [
    setLoadings,
    payloadPropostaAcordo,
    montarPayloadPropostaAcordo,
    onClose,
  ]);

  const enviarMemoriaDeCalculo = useCallback(async () => {
    setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(true));
    try {
      const payload = montarPayloadPropostaAcordo(payloadPropostaAcordo);
      await enviarMemoriaDeCalculoPorEmail(idProcesso, payload);
      toast.success('E-mail enviado com sucesso!');
      onClose();
    } catch (error) {
      toast.error(error?.response?.data?.message, { style: { width: '392px' } });
    } finally {
      setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(false));
    }
  }, [
    setLoadings,
    payloadPropostaAcordo,
    montarPayloadPropostaAcordo,
    idProcesso,
    onClose,
  ]);

  return (
    <>
      <Grid24 container isFormContainer spacing="1">
        <span>Você pode imprimir o relatório de Memória de Cálculo ou enviá-lo por e-mail ao devedor. Qual ação deseja realizar?</span>
      </Grid24>


      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '10px' }}>
        <Button
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          onClick={imprimirMemoriaDeCalculo}
        >
          Imprimir
        </Button>
        <Button
          onClick={enviarMemoriaDeCalculo}
        >
          Enviar e-mail
        </Button>
      </div>
    </>
  );
}
export default DialogMemoriaDeCalculo;
